"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssessmentCompletionSummary = void 0;
/**
 * It holds information about assessment completion
 *
 * @property {number}     assigned            - total assessments assigned
 * @property {number}     submitted           - total assessments submitted
 */
var AssessmentCompletionSummary = /** @class */ (function () {
    function AssessmentCompletionSummary(summary) {
        if (summary === void 0) { summary = {}; }
        Object.assign(this, summary);
    }
    return AssessmentCompletionSummary;
}());
exports.AssessmentCompletionSummary = AssessmentCompletionSummary;
